import React from 'react'

function DT1() {
    return (
        <div>
            <h2>DT1</h2>
        </div>
    )
}

export default DT1
